"use client";

import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  EmailShareButton,
  WhatsappIcon,
  FacebookIcon,
  XIcon,
  LinkedinIcon,
  RedditIcon,
  TelegramIcon,
  EmailIcon,
} from "react-share";

const ShareComponent = ({ url, title }) => {
  return (
    <div className="flex gap-2">
      {/* Facebook Share Button */}
      <FacebookShareButton
        url={url}
        quote={title}
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <FacebookIcon size={40} round />
      </FacebookShareButton>

      {/* Twitter Share Button */}
      <TwitterShareButton
        url={url}
        title={title}
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <XIcon size={40} round />
      </TwitterShareButton>

      {/* Whatsapp Share Button */}
      <WhatsappShareButton
        url={url}
        title={title}
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <WhatsappIcon size={40} round />
      </WhatsappShareButton>

      {/* LinkedIn Share Button */}
      <LinkedinShareButton
        url={url}
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <LinkedinIcon size={40} round />
      </LinkedinShareButton>

      {/* Reddit Share Button */}
      <RedditShareButton
        url={url}
        title={title}
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <RedditIcon size={40} round />
      </RedditShareButton>

      {/* Telegram Share Button */}
      <TelegramShareButton
        url={url}
        title={title}
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <TelegramIcon size={40} round />
      </TelegramShareButton>

      {/* Email Share Button */}
      <EmailShareButton
        url={url}
        subject={title}
        body="Check out this link: "
        className="transition duration-300 ease-in-out transform hover:scale-110"
      >
        <EmailIcon size={40} round />
      </EmailShareButton>

      {/* ... */}
    </div>
  );
};

export default ShareComponent;
